<template>
  <div class="home-box">
    <v-progress-linear indeterminate color="orange" v-if="loading"></v-progress-linear>
    <v-layout row v-if="errors">
      <v-flex>
        <Alert @dismissed="onDismissed" :text="errors"></Alert>
      </v-flex>
    </v-layout>
    <v-card>
      <v-card-title dark>
        <h3 class="ma-2 orange--text">Board Meeting | Month: {{ month }}</h3>
        <v-spacer></v-spacer>
        <go-back-btn></go-back-btn>
      </v-card-title>
      <v-divider color="orange"></v-divider>
      <v-form class="pa-5" v-if="boardMeeting && !loading">
        <v-row>
          <v-col cols="3" md="3" sm="12">
            <div class="subtitle-1">Venue</div>
            <div class="caption">{{ boardMeeting.venue }}</div>
          </v-col>
          <v-col cols="3" md="3" sm="12">
            <div class="subtitle-1">Date</div>
            <div class="caption">{{ boardMeeting.date }}</div>
          </v-col>
          <v-col cols="3" md="3" sm="12">
            <div class="subtitle-1">No of Board Members</div>
            <div class="caption">{{ boardMeeting.no_of_board_members }}</div>
          </v-col>
          <!-- <v-col cols="3" md="3" sm="12">
            <div class="subtitle-1">No of Outside Cabinet Officers</div>
            <div class="caption">{{ boardMeeting.no_of_attendance }}</div>
          </v-col> -->
        </v-row>
        <v-row>
          <!-- <v-col cols="3" md="3" sm="12" v-if="boardMeeting.treasure_report">
            <div class="subtitle-1">Treasure Report</div>
            <a :href="boardMeeting.treasure_report" target="_blank"> View Treasure Report</a>
          </v-col> -->
          <v-col cols="3" md="3" sm="12">
            <div class="subtitle-1">Submitted Date</div>
            <div class="caption">{{ dateFormat(boardMeeting.created_at) }}</div>
          </v-col>
        </v-row>
        <v-divider></v-divider>
        <v-row v-if="boardMeeting.documents">
          <v-col cols="3" v-for="item in boardMeeting.documents" :key="item.uuid">
            <v-card v-if="item.type === 'pdf'" @click="openImage(item.path)">
              <v-chip class="ma-2" color="pink" label text-color="white">
                <v-icon left>
                  mdi-file-pdf-box
                </v-icon>
                PDF document
              </v-chip>
            </v-card>
            <v-card v-else @click="openImage(item.path)">
              <v-img :src="item.path" height="150" class="grey darken-4"></v-img>
              <v-divider></v-divider>
              <v-card-actions class="text-h6 pa-2">
                Photo
              </v-card-actions>
            </v-card>
          </v-col>
        </v-row>
        <v-divider></v-divider>
        <MembersList v-if="members && !loading" :members="members"></MembersList>
      </v-form>
    </v-card>

    <Snackbars :text="successMsg" :snackbar="snackbar" :color="'success'" @classSnackbar="closeSnackbar" />
  </div>
</template>

<script>
import GoBackBtn from "@/components/shared/GoBackBtn";
import { createNamespacedHelpers } from "vuex";
const { mapGetters } = createNamespacedHelpers("auth");
import Alert from "@/components/shared/Alert";
import Snackbars from "@/components/shared/Snackbars";
import MembersList from "@/components/shared/MembersList";
import { ActivityService } from "../../../services/activity-service.js";
import { checkError } from "@/config/errors.js";
import moment from "moment";

export default {
  name: "BoardMeeting",

  components: { GoBackBtn, Alert, Snackbars, MembersList },

  data: () => ({
    month: "",
    role: localStorage.getItem("role"),
    loading: false,
    errors: null,
    snackbar: false,
    successMsg: "",
    form: {
      pending_comment: "",
    },
    boardMeeting: [],
    confirm: false,
    members: [],
  }),

  mounted() {
    this.month = this.$route.params.month;
    this.getBoardMeeting();
  },

  computed: {
    ...mapGetters({
      defaultExam: "defaultExam",
      defaultSubject: "defaultSubject",
    }),
  },

  methods: {
    getBoardMeeting() {
      if (this.$route.params.aId !== null) {
        this.loading = true;
        ActivityService.getActivityInfo("board_meeting", this.$route.params.aId)
          .then((response) => {
            this.loading = false;
            if (response.data.data) {
              this.boardMeeting = response.data.data;
              this.members = response.data.data.members;
            }
          })
          .catch((error) => {
            this.loading = false;
            this.boardMeeting = [];
            this.members = [];
            let data = error.response.data;
            let errorOutput = checkError.errorFormatting(data);
            this.errors = errorOutput;
          });
      }
    },
    pending() { },
    submit() { },
    onDismissed() {
      this.errors = null;
    },
    closeSnackbar() {
      this.snackbar = false;
    },
    reset() {
      this.form.name = "";
    },
    openImage(path) {
      window.open(path, "_blank");
    },

    dateFormat(dateToFormat){
      return moment(dateToFormat, "YYYY-MM-DD").format("DD/MM/YYYY");
    }
  },
};
</script>
